// JMUI TODO implement session storage alternative (or remove usage if not needed)
const store = {
  get(_key: string) {
    return undefined;
  },
  set(_key: string, _value: string) {
    return;
  },
  remove(_key: string) {
    return;
  },
};

export function get(key: string) {
  return store.get(key);
}

export function set(key: string, value: string) {
  return store.set(key, value);
}

export function remove(key: string) {
  return store.remove(key);
}
